import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW6500Component } from './kymw6500.component';
import { KYMW6501Module } from '../kymw6501/kymw6501.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjChartModule } from '@grapecity/wijmo.angular2.chart';
import { GetCwsTimeSaleListService } from './api-services/get-cws-time-sale-list.service';
import { SaveCwsTimeSaleListService } from './api-services/save-cws-time-sale-list.service';
/**
/**
 * ECタイムセールマスタ一覧画面 モジュール設定クラス
 *
 * @export KYMW6500Module
 * @class KYMW6500Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    KYMW6501Module,
    AppCommonsModule,
    WjInputModule,
    WjChartModule,
  ],
  declarations: [
    KYMW6500Component,
  ],
  providers: [
    GetCwsTimeSaleListService,
    SaveCwsTimeSaleListService,
  ],
})
export class KYMW6500Module {

}
